import { render, staticRenderFns } from "./news_category.vue?vue&type=template&id=66f8f7af&scoped=true&"
import script from "./news_category.vue?vue&type=script&lang=js&"
export * from "./news_category.vue?vue&type=script&lang=js&"
import style0 from "./news_category.vue?vue&type=style&index=0&id=66f8f7af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f8f7af",
  null
  
)

export default component.exports